
export const usePresentations = () => 
[
    { title: 'Sales', path: '/sales', component: 'Sales/Sales.vue' },
    { title: 'Sales (Full)', path: '/sales-full', component: 'SalesFull/SalesFull.vue' },
    { title: 'Reseller', path: '/reseller', component: 'Reseller/Reseller.vue' },
    { title: 'Onboarding', path: '/onboarding', component: 'Onboarding/Onboarding.vue' },
    { title: 'Presidian Kickoff', path: '/presidian', component: 'PresidianKickoff/PresidianKickoff.vue' },
    { title: 'Global Reseller', path: '/global', component: 'Global/Global.vue' },  
]

